import { CookieOptions } from 'ngx-cookie';

export const environment = {
  production: false,
  apiUrl: 'https://localhost:8000/',
  recaptchaV2Key: '6LfIah4pAAAAAEC5V_en9zxPAWMkp9rS_P1UoO6J',
  recaptchaV3Key: '6LcRKh8pAAAAAPfumii7513zhyxOxlIf6Q5U3QRN',
  firebase: {
    projectId: 'unbox-tg-bot',
    appId: '1:144260811299:web:9facfdcc8c518415aaff96',
    storageBucket: 'unbox-tg-bot.appspot.com',
    apiKey: 'AIzaSyAX2YQxXRYA7FwpFZWuXVsYf0Wr5J0nwqY',
    authDomain: 'unbox-tg-bot.firebaseapp.com',
    messagingSenderId: '144260811299',
    measurementId: 'G-0BMED4SB12',
  },
  supabaseUrl: 'https://zpxjrufoixxiuxyyrgzd.supabase.co',
  supabaseAnonKey: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InpweGpydWZvaXh4aXV4eXlyZ3pkIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MjgxNjE1MzEsImV4cCI6MjA0MzczNzUzMX0.p269e1Waur-kP_2Fjls2VwB02LvU5idkINOnkKQsBls'
};

export const cookieOptions: CookieOptions = {
  // domain: environment.domain,
  sameSite: 'lax',
  path: '/',
  expires: (() => {
    const today = new Date();
    today.setFullYear(today.getFullYear() + 1);
    return today;
  })(),
};